<template>
  <div>
    <q-chip class="chipEjecucion" v-if="value === 'EN EJECUCIÓN'" outline>
      <q-avatar>
        <img
          :src="require('@/assets/img/history-black-24-dp.svg')"
          alt="fase ejecutado"
        />
      </q-avatar>
      {{ value }}
    </q-chip>
    <q-chip class="chipProyecto" v-if="value === 'EN PROYECTO' || value === 'EN ELABORACIÓN'" outline>
      <q-avatar>
        <img
          :src="require('@/assets/img/pending-actions-black-24-dp-1.svg')"
          alt="fase proyecto"
        />
      </q-avatar>
      {{ value }}
    </q-chip>
    <q-chip class="chipFinalizada" v-if="value === 'FINALIZADA' || value === 'APROBADO'" outline>
      <q-avatar>
        <img
          :src="require('@/assets/img/done_white_24dp.svg')"
          alt="fase finalizada"
        />
      </q-avatar>
      {{ value }}
    </q-chip>
    <q-chip class="chipPlanificado" v-if="value === 'PLANIFICADO'" outline>
      <q-avatar>
        <img
          :src="require('@/assets/img/Planificado.svg')"
          alt="fase PLANIFICADO"
        />
      </q-avatar>
      {{ value }}
    </q-chip>
    <q-chip class="chipEjecucion" v-if="value === 'EJECUTADO'" outline>
      <q-avatar>
        <img
          :src="require('@/assets/img/history-black-24-dp.svg')"
          alt="fase ejecutado"
        />
      </q-avatar>
      {{ value }}
    </q-chip>
  </div>
</template>
<script>
import { QAvatar } from 'quasar';
export default {
  props: {
    value: String
  },
  components: {
    QAvatar
  },
  data () {
    return {};
  }
};
</script>
<style lang="scss" scoped>
.chipEjecucion {
  background-color: #ff8d60 !important;
}
.chipProyecto {
  background-color: #fdce62 !important;
  color: #765518 !important;
}
.chipFinalizada {
  background-color: #119f93 !important;
}
.chipPlanificado {
  background-color: #ffefd5 !important;
  color: #424242 !important;
}
.q-chip--outline {
  color: white;
  font-family: DINPro;
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.17px;
  padding-right: 8px;
  border: none;
}
.q-chip__content {
  display: flex;
  justify-content: center;
  align-items: center;
}
.q-avatar {
  height: 16px;
  margin-right: 4px;
}
</style>
